// Add Server's registration (docs/features/pwa-and-your-macs.md): the window `addserver` and Home's item.
import { registerWindow } from '../../core/windows.js'
import { registerHomeItem } from '../../core/home-items.js'

registerWindow('addserver', { module: () => import('./addserver.js'), css: 'windows/addserver/addserver.css', title: () => 'Add Server', place: ['home', 'front'] })
registerHomeItem({ id: 'addserver', label: 'Add Server', symbol: 'link.badge.plus', needs: '', section: 'toolbar', order: 100 })
